import { GRADE_LIST } from "@/pages/SchoolDiagnoseReport/const";
import React from "react";
import { UserInfo } from "@/pages/SchoolDiagnoseReport/type";

type UserInformationType = {
  userInfo: UserInfo;
};
const UserInformation = (props: UserInformationType) => {
  const {
    userInfo = {
      stu_name: "",
      area_name: "",
      year: 0,
      grade: 1,
    },
  } = props;
  return (
    <div className="school_diagnose__userinfo">
      <div className="school_diagnose__right-title">
        <div className="school_diagnose__right-title-prompt"></div>
        <span>用户信息</span>
      </div>
      <div className="school_diagnose__userinfo-desc-wrapper">
        <span className="school_diagnose__userinfo-desc">
          姓名：{userInfo?.stu_name}
        </span>
        <span className="school_diagnose__userinfo-desc">
          高考地区：{userInfo?.area_name}
        </span>
        <span className="school_diagnose__userinfo-desc">
          高考年份：{userInfo?.year}
        </span>
        <span className="school_diagnose__userinfo-desc">
          当前年级：{GRADE_LIST[userInfo?.grade]}
        </span>
      </div>
    </div>
  );
};

export default UserInformation;
